export default "__VITE_ASSET__Dw7D4pRy__"